import { render, staticRenderFns } from "./BudgetSummaryEdit.vue?vue&type=template&id=242545bd&scoped=true"
import script from "./BudgetSummaryEdit.vue?vue&type=script&lang=js"
export * from "./BudgetSummaryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242545bd",
  null
  
)

export default component.exports